import { create } from 'zustand';

export const useRegionSwitcherStore = create((set) => ({
  isOpen: false,
  openRegionSwitcher: () => set({ isOpen: true }),
  closeRegionSwitcher: () => set({ isOpen: false }),
  toggleRegionSwitcher: () => set((state) => ({ isOpen: !state.isOpen })),
}));
